module.exports = __webpack_public_path__ + "img/skull_19.a79e85dc.png";